import { css } from 'styled-components';
import { rgba } from 'polished';

const DXC_PALETTE = {
  midnightBlue: '#0E1020',
  red: '#D14600',
  trueBlue: '#4995FF',
  canvas: '#F6F3F0',
  royal: '#004AAC',
  white: '#FFFFFF',
};

export const COLORS = {
  midnightBlue: DXC_PALETTE.midnightBlue,
  maroonFlush: DXC_PALETTE.red,
  indigo: DXC_PALETTE.trueBlue,
  aquaHaze: DXC_PALETTE.canvas,
  alto: '#d4d4d4',
};

export const MEDIA_QUERIES = {
  mobile: '660px',
  tablet: '914px',
  laptop: '1400px',
};

const FONT_HEADINGS = "'GT Standard', sans-serif";
const FONT_BODY = "'Inter', sans-serif";

export const TYPOGRAPHY = {
  headingMedium: css`
    font-family: ${FONT_HEADINGS};
    font-size: 30px;
    font-weight: 700;
  `,
  headingSmall: css`
    font-family: ${FONT_HEADINGS};
    font-size: 16px;
    font-weight: 500;
  `,
  body: css`
    font-family: ${FONT_BODY};
    font-size: 16px;
    font-weight: normal;
  `,
  bodySemibold: css`
    font-family: ${FONT_BODY};
    font-size: 16px;
    font-weight: 600;
  `,
  bodySmall: css`
    font-family: ${FONT_BODY};
    font-size: 14px;
    font-weight: normal;
  `,
  bodySmallSemibold: css`
    font-family: ${FONT_BODY};
    font-size: 14px;
    font-weight: 600;
  `,
  inputRegular: css`
    font-family: ${FONT_BODY};
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
  `,
  adminInputSemibold: css`
    font-family: ${FONT_BODY};
    font-size: 20px;
    font-weight: 600;
    line-height: 36px;
    letter-spacing: 0.3px;
  `,
  adminTextarea: css`
    font-family: ${FONT_BODY};
    font-size: 20px;
    line-height: 36px;
    letter-spacing: 0.3px;
  `,
  pincode: css`
    font-family: ${FONT_HEADINGS};
    font-size: 30px;

    @media (min-width: ${MEDIA_QUERIES.mobile}) {
      font-size: 46px;
    }
  `,
};

export const BOX_SHADOWS = {
  card: css`
    box-shadow: 0 15px 22px -10px ${rgba(COLORS.midnightBlue, 0.1)};
  `,
  button: css`
    box-shadow: 0 0 0 1px ${COLORS.indigo};
  `,
  login: css`
    box-shadow: -12px 0 26px 0 ${rgba(COLORS.midnightBlue, 0.1)};
  `,
  list: css`
    box-shadow: 0 2px 6px 0 ${rgba(COLORS.midnightBlue, 0.1)};
  `,
};

export const Z_INDEX = {
  rightMenu: 2,
};
